import * as ambassadorWixServiceFeesV1Rule from './service-fees-v1-rule-service-fees.http.js';
import * as ambassadorWixServiceFeesV1RuleTypes from './service-fees-v1-rule-service-fees.types.js';
import * as ambassadorWixServiceFeesV1RuleUniversalTypes from './service-fees-v1-rule-service-fees.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function calculateServiceFees(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.CalculateServiceFeesRequest,
  ambassadorWixServiceFeesV1RuleTypes.CalculateServiceFeesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.CalculateServiceFeesResponse,
  ambassadorWixServiceFeesV1RuleTypes.CalculateServiceFeesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.calculateServiceFees(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/calculate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createRule(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.CreateRuleRequest,
  ambassadorWixServiceFeesV1RuleTypes.CreateRuleRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.CreateRuleResponse,
  ambassadorWixServiceFeesV1RuleTypes.CreateRuleResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.createRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/rules',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRule(): __PublicMethodMetaInfo<
  'GET',
  { ruleId: string },
  ambassadorWixServiceFeesV1RuleUniversalTypes.GetRuleRequest,
  ambassadorWixServiceFeesV1RuleTypes.GetRuleRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.GetRuleResponse,
  ambassadorWixServiceFeesV1RuleTypes.GetRuleResponse
> {
  const payload = { ruleId: ':ruleId' } as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.getRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/rules/{ruleId}',
    pathParams: { ruleId: 'ruleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateRule(): __PublicMethodMetaInfo<
  'PATCH',
  { ruleId: string },
  ambassadorWixServiceFeesV1RuleUniversalTypes.UpdateRuleRequest,
  ambassadorWixServiceFeesV1RuleTypes.UpdateRuleRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.UpdateRuleResponse,
  ambassadorWixServiceFeesV1RuleTypes.UpdateRuleResponse
> {
  const payload = { rule: { id: ':ruleId' } } as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.updateRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/rules/{rule.id}',
    pathParams: { ruleId: 'ruleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteRule(): __PublicMethodMetaInfo<
  'DELETE',
  { ruleId: string },
  ambassadorWixServiceFeesV1RuleUniversalTypes.DeleteRuleRequest,
  ambassadorWixServiceFeesV1RuleTypes.DeleteRuleRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.DeleteRuleResponse,
  ambassadorWixServiceFeesV1RuleTypes.DeleteRuleResponse
> {
  const payload = { ruleId: ':ruleId' } as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.deleteRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/rules/{ruleId}',
    pathParams: { ruleId: 'ruleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listRules(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.ListRulesRequest,
  ambassadorWixServiceFeesV1RuleTypes.ListRulesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.ListRulesResponse,
  ambassadorWixServiceFeesV1RuleTypes.ListRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.listRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/rules',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryRules(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.QueryRulesRequest,
  ambassadorWixServiceFeesV1RuleTypes.QueryRulesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.QueryRulesResponse,
  ambassadorWixServiceFeesV1RuleTypes.QueryRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixServiceFeesV1Rule.queryRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/rules/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateRules(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkCreateRulesRequest,
  ambassadorWixServiceFeesV1RuleTypes.BulkCreateRulesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkCreateRulesResponse,
  ambassadorWixServiceFeesV1RuleTypes.BulkCreateRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.bulkCreateRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/rules/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRules(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRulesRequest,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRulesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRulesResponse,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.bulkUpdateRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/bulk/rules/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteRules(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkDeleteRulesRequest,
  ambassadorWixServiceFeesV1RuleTypes.BulkDeleteRulesRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkDeleteRulesResponse,
  ambassadorWixServiceFeesV1RuleTypes.BulkDeleteRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.bulkDeleteRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/rules/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRuleTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRuleTagsRequest,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRuleTagsRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRuleTagsResponse,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRuleTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.bulkUpdateRuleTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/rules/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRuleTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRuleTagsByFilterRequest,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRuleTagsByFilterRequest,
  ambassadorWixServiceFeesV1RuleUniversalTypes.BulkUpdateRuleTagsByFilterResponse,
  ambassadorWixServiceFeesV1RuleTypes.BulkUpdateRuleTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixServiceFeesV1Rule.bulkUpdateRuleTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/rules/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Rule as RuleOriginal,
  RuleValueOneOf as RuleValueOneOfOriginal,
  RuleRequirementsOneOf as RuleRequirementsOneOfOriginal,
  RuleConditionsOneOf as RuleConditionsOneOfOriginal,
  RuleConditionTypeOptionsOneOf as RuleConditionTypeOptionsOneOfOriginal,
  RuleTaxesOneOf as RuleTaxesOneOfOriginal,
  CommonMoney as CommonMoneyOriginal,
  Money as MoneyOriginal,
  Condition as ConditionOriginal,
  ConditionValueOneOf as ConditionValueOneOfOriginal,
  ExpectedType as ExpectedTypeOriginal,
  Value as ValueOriginal,
  ValueWithLiterals as ValueWithLiteralsOriginal,
  ExpectedFieldType as ExpectedFieldTypeOriginal,
  ExpectedFieldTypeWithLiterals as ExpectedFieldTypeWithLiteralsOriginal,
  _Number as _NumberOriginal,
  Operation as OperationOriginal,
  OperationWithLiterals as OperationWithLiteralsOriginal,
  List as ListOriginal,
  ConditionTree as ConditionTreeOriginal,
  ConditionTreeLeftConditionNodeOneOf as ConditionTreeLeftConditionNodeOneOfOriginal,
  ConditionTreeRightConditionNodeOneOf as ConditionTreeRightConditionNodeOneOfOriginal,
  Operator as OperatorOriginal,
  OperatorWithLiterals as OperatorWithLiteralsOriginal,
  ConditionsType as ConditionsTypeOriginal,
  ConditionsTypeWithLiterals as ConditionsTypeWithLiteralsOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeWithLiterals as ConditionTypeWithLiteralsOriginal,
  RoundingStrategy as RoundingStrategyOriginal,
  RoundingStrategyWithLiterals as RoundingStrategyWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  CalculateServiceFeesRequest as CalculateServiceFeesRequestOriginal,
  Order as OrderOriginal,
  PriceSummary as PriceSummaryOriginal,
  ShippingInformation as ShippingInformationOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Platform as PlatformOriginal,
  PlatformValue as PlatformValueOriginal,
  PlatformValueWithLiterals as PlatformValueWithLiteralsOriginal,
  Locale as LocaleOriginal,
  CalculateServiceFeesResponse as CalculateServiceFeesResponseOriginal,
  CalculatedFee as CalculatedFeeOriginal,
  CreateRuleRequest as CreateRuleRequestOriginal,
  CreateRuleResponse as CreateRuleResponseOriginal,
  GetRuleRequest as GetRuleRequestOriginal,
  GetRuleResponse as GetRuleResponseOriginal,
  UpdateRuleRequest as UpdateRuleRequestOriginal,
  UpdateRuleResponse as UpdateRuleResponseOriginal,
  DeleteRuleRequest as DeleteRuleRequestOriginal,
  DeleteRuleResponse as DeleteRuleResponseOriginal,
  ListRulesRequest as ListRulesRequestOriginal,
  ListRulesResponse as ListRulesResponseOriginal,
  QueryRulesRequest as QueryRulesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryRulesResponse as QueryRulesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateRulesRequest as BulkCreateRulesRequestOriginal,
  BulkCreateRulesResponse as BulkCreateRulesResponseOriginal,
  BulkRuleResult as BulkRuleResultOriginal,
  CommonItemMetadata as CommonItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  CommonBulkActionMetadata as CommonBulkActionMetadataOriginal,
  BulkUpdateRulesRequest as BulkUpdateRulesRequestOriginal,
  MaskedRule as MaskedRuleOriginal,
  BulkUpdateRulesResponse as BulkUpdateRulesResponseOriginal,
  BulkDeleteRulesRequest as BulkDeleteRulesRequestOriginal,
  BulkDeleteRulesResponse as BulkDeleteRulesResponseOriginal,
  BulkUpdateRuleTagsRequest as BulkUpdateRuleTagsRequestOriginal,
  BulkUpdateRuleTagsResponse as BulkUpdateRuleTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  BulkUpdateRuleTagsResult as BulkUpdateRuleTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateRuleTagsByFilterRequest as BulkUpdateRuleTagsByFilterRequestOriginal,
  BulkUpdateRuleTagsByFilterResponse as BulkUpdateRuleTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateRuleTagsApplicationErrors as BulkUpdateRuleTagsApplicationErrorsOriginal,
  BulkUpdateRuleTagsByFilterApplicationErrors as BulkUpdateRuleTagsByFilterApplicationErrorsOriginal,
} from './service-fees-v1-rule-service-fees.types.js';
